import script from "./TboFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TboFooter.vue?vue&type=script&setup=true&lang=ts"

import "./TboFooter.vue?vue&type=style&index=0&id=ab0cf662&lang=scss"

const __exports__ = script;

export default __exports__